<template>
  <div class="container">
    <!--系统主界面-->
    <div class="header">
      <!--系统头部-->
      <rtas-header></rtas-header>
    </div>
    <!--user-->
    <div class="user">
      <el-dialog
        title="账户信息"
        top="20px"
        :visible.sync="dialogVisible"
        width="600px"
        :before-close="handleClose">
        <!--用户组件-->
        <personifo></personifo>
      </el-dialog>
    </div>
    <div class="main">
      <!--系统中心区域-->
      <el-container>
        <!--侧边栏菜单-->
        <rtas-aside></rtas-aside>
        <el-main>
          <rtas-tags></rtas-tags>
          <!--子路由变换区-->
          <keep-alive :include="tagsList">
            <router-view v-if="isRouterAlive"></router-view>
          </keep-alive>
        </el-main>
      </el-container>
    </div>

    <div class="footer">
      <!--系统底部-->
      <rtas-footer></rtas-footer>
    </div>
  </div>
</template>

<script>
  /*引入公共组件*/
  import rtasAside from '../components/aside'
  import rtasFooter from '../components/footer'
  import rtasHeader from '../components/header'
  import rtasTags from '../components/tags'

  /*引入用户信息页面*/
  import personifo from '../user/personIfo'

  import bus from './bus'
    export default {
      provide (){
        return {
          reload: this.reload
        }
      },
      name: "system",
      components:{
        rtasAside,
        rtasFooter,
        rtasHeader,
        rtasTags,
        /*使用用户信息组件*/
        personifo
      },
        data(){
          return{
            isRouterAlive: true,
            tagsList: [],
            dialogVisible: false,
          }
        },
      methods: {
        /*关闭用户信息管理窗口*/
        handleClose(done) {
          done();
        },
        reload () {
          this.isRouterAlive =false;
          this.$nextTick(function () {
            this.isRouterAlive = true;
          })
        }
      },
      mounted () {
        bus.$on('personIfo',(msg)=>{
         this.dialogVisible = true;
        })
      },
      created() {
        // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
        bus.$on('tags', msg => {
          let arr = [];
          for (let i = 0, len = msg.length; i < len; i++) {
            msg[i].name && arr.push(msg[i].name);
          }
          this.tagsList = arr;
        })
      }
  }
</script>

<style scoped>
  *{
    padding: 0;
    margin: 0;
  }
  .container{
    min-width: 1200px;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

  }
  .header{
    width: 100%;
    height: 6%;
    background-color: skyblue;
  }
  .main{
    width: 100%;
    height: 89%;
    min-height: calc(100% - 77px);
  }
  .el-mian{
    width: 60%;
  }
  .el-container{
    width: 100%;
    height: 100%;
  }
  .footer{
    width: 100%;
    height: 5%;
    background-color: #F1F3F4;
  }
</style>



// WEBPACK FOOTER //
// src/components/system.vue